export enum StoreCategoryEnum {
  Retailer = 'Retailer',
  Wholesaler = 'Wholesaler',
  Distributor = 'Distributor',
  Manufacturer = 'Manufacturer',
}
